"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipCouponParticipateSchema = exports.MembershipCouponParticipateFailSchema = exports.MEMBERSHIP_COUPON_PARTICIPATE_ERROR_CODE = exports.MembershipCouponAvailableSchema = exports.MEMBERSHIP_COUPON_FAIL_CODE = exports.MembershipSalesHistorySchema = void 0;
var zod_1 = require("zod");
// ── Sales History ──────────────────────────────────────────────────────────────
var MemberClassInfoBaseSchema = zod_1.z.object({
    classCode: zod_1.z.string(),
    weight: zod_1.z.number(),
    startAt: zod_1.z.string().optional().nullable(),
    endAt: zod_1.z.string().optional().nullable(),
    targetSalesCount: zod_1.z.number(),
    targetSalesAmount: zod_1.z.number(),
});
exports.MembershipSalesHistorySchema = zod_1.z.object({
    classCode: zod_1.z.string(),
    weight: zod_1.z.number(),
    startAt: zod_1.z.string().optional().nullable(),
    endAt: zod_1.z.string().optional().nullable(),
    appliedAt: zod_1.z.string().optional(),
    salesCount: zod_1.z.number(),
    salesAmount: zod_1.z.number(),
    expectedMemberClass: MemberClassInfoBaseSchema,
    nextMemberClass: MemberClassInfoBaseSchema.extend({
        startAt: zod_1.z.string(),
        endAt: zod_1.z.string(),
    }).nullable(),
    isTrial: zod_1.z.boolean().optional(),
});
// ── Coupon Available ───────────────────────────────────────────────────────────
exports.MEMBERSHIP_COUPON_FAIL_CODE = {
    NOT_VIP: 'NOT_VIP',
    NO_PROMOTION_AVAILABLE: 'NO_PROMOTION_AVAILABLE',
    EXPIRED_PERIOD: 'EXPIRED_PERIOD',
    NO_VERIFIED_PHONE: 'NO_VERIFIED_PHONE',
    ALREADY_PARTICIPATED: 'ALREADY_PARTICIPATED',
};
exports.MembershipCouponAvailableSchema = zod_1.z.object({
    available: zod_1.z.boolean(),
    availableUntil: zod_1.z.string().nullish(),
    failCode: zod_1.z
        .enum([
        exports.MEMBERSHIP_COUPON_FAIL_CODE.NOT_VIP,
        exports.MEMBERSHIP_COUPON_FAIL_CODE.NO_PROMOTION_AVAILABLE,
        exports.MEMBERSHIP_COUPON_FAIL_CODE.EXPIRED_PERIOD,
        exports.MEMBERSHIP_COUPON_FAIL_CODE.NO_VERIFIED_PHONE,
        exports.MEMBERSHIP_COUPON_FAIL_CODE.ALREADY_PARTICIPATED,
    ])
        .nullish(),
});
// ── Coupon Participate ─────────────────────────────────────────────────────────
exports.MEMBERSHIP_COUPON_PARTICIPATE_ERROR_CODE = {
    NOT_VIP: 'NOT_VIP',
    NO_PROMOTION_AVAILABLE: 'NO_PROMOTION_AVAILABLE',
    NO_VERIFIED_PHONE: 'NO_VERIFIED_PHONE',
    EXPIRED_PERIOD: 'EXPIRED_PERIOD',
    ALREADY_PARTICIPATED: 'ALREADY_PARTICIPATED',
    INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
};
exports.MembershipCouponParticipateFailSchema = zod_1.z.object({
    code: zod_1.z.enum([
        exports.MEMBERSHIP_COUPON_PARTICIPATE_ERROR_CODE.NOT_VIP,
        exports.MEMBERSHIP_COUPON_PARTICIPATE_ERROR_CODE.NO_PROMOTION_AVAILABLE,
        exports.MEMBERSHIP_COUPON_PARTICIPATE_ERROR_CODE.NO_VERIFIED_PHONE,
        exports.MEMBERSHIP_COUPON_PARTICIPATE_ERROR_CODE.EXPIRED_PERIOD,
        exports.MEMBERSHIP_COUPON_PARTICIPATE_ERROR_CODE.ALREADY_PARTICIPATED,
        exports.MEMBERSHIP_COUPON_PARTICIPATE_ERROR_CODE.INTERNAL_SERVER_ERROR,
    ]),
    message: zod_1.z.string(),
    participatedAt: zod_1.z.string(),
});
exports.MembershipCouponParticipateSchema = zod_1.z.union([exports.MembershipCouponParticipateFailSchema, zod_1.z.object({})]);
